var _rect, _path, _path2, _path3, _path4, _path5, _stop, _stop2, _stop3, _stop4, _stop5, _stop6, _stop7, _stop8, _stop9, _stop10, _stop11, _stop12, _stop13, _stop14, _stop15, _stop16, _stop17, _stop18, _stop19, _stop20;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import { useUniqueInlineId } from '@inline-svg-unique-id/react';
import * as React from "react";
var SvgAuctions = function SvgAuctions(props) {
  var _id10 = useUniqueInlineId();
  var _id9 = useUniqueInlineId();
  var _id8 = useUniqueInlineId();
  var _id7 = useUniqueInlineId();
  var _id6 = useUniqueInlineId();
  var _id5 = useUniqueInlineId();
  var _id4 = useUniqueInlineId();
  var _id3 = useUniqueInlineId();
  var _id2 = useUniqueInlineId();
  var _id = useUniqueInlineId();
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 615,
    height: 310,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "auctions_svg__a",
    width: 615,
    height: 310,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 615,
    height: 310,
    fill: "#F6F9FE",
    rx: 16
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#auctions_svg__a)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 72,
    cy: 185,
    r: 40,
    fill: "url(#".concat(_id, ")")
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 72,
    cy: 185,
    r: 50,
    fill: "url(#".concat(_id2, ")"),
    opacity: 0.2
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M55.525 185.84h-4v4.04h-2.22v-4.04h-3.98v-2.1h3.98v-4.06h2.22v4.06h4v2.1Zm6.106 1.08c0 .573-.127 1.147-.38 1.72-.24.573-.62 1.107-1.14 1.6h7.14v1.82h-9.36l-.28-1.18c.627-.6 1.087-1.193 1.38-1.78.306-.6.46-1.313.46-2.14 0-.267-.047-.607-.14-1.02h-2.36v-1.56h1.86a19.869 19.869 0 0 1-.44-1.58c-.107-.48-.16-.98-.16-1.5 0-.813.18-1.527.54-2.14a3.742 3.742 0 0 1 1.56-1.42c.666-.347 1.433-.52 2.3-.52 1.4 0 2.5.393 3.3 1.18.8.787 1.26 1.813 1.38 3.08h-2.12c-.067-.707-.32-1.28-.76-1.72-.44-.44-1.014-.66-1.72-.66-.667 0-1.214.213-1.64.64-.427.413-.64 1.013-.64 1.8 0 .413.053.827.16 1.24.12.413.293.947.52 1.6h3.62v1.56h-3.18c.066.36.1.687.1.98Zm6.87-6.9v-2.14h4.52V192h-2.4v-11.98H68.5Zm6.912 4.82c0 2.253.4 4.02 1.2 5.3.8 1.267 2.133 1.9 4 1.9s3.2-.64 4-1.92c.8-1.28 1.2-3.04 1.2-5.28 0-2.227-.4-3.973-1.2-5.24-.8-1.28-2.133-1.92-4-1.92s-3.2.633-4 1.9c-.8 1.267-1.2 3.02-1.2 5.26Zm8.12 0c0 1.627-.2 2.873-.6 3.74-.4.867-1.173 1.3-2.32 1.3-1.16 0-1.94-.433-2.34-1.3-.4-.867-.6-2.113-.6-3.74 0-1.613.2-2.847.6-3.7.4-.853 1.18-1.28 2.34-1.28 1.147 0 1.92.433 2.32 1.3.4.853.6 2.08.6 3.68Zm4.341 0c0 2.253.4 4.02 1.2 5.3.8 1.267 2.133 1.9 4 1.9s3.2-.64 4-1.92c.8-1.28 1.2-3.04 1.2-5.28 0-2.227-.4-3.973-1.2-5.24-.8-1.28-2.133-1.92-4-1.92s-3.2.633-4 1.9c-.8 1.267-1.2 3.02-1.2 5.26Zm8.12 0c0 1.627-.2 2.873-.6 3.74-.4.867-1.173 1.3-2.32 1.3-1.16 0-1.94-.433-2.34-1.3-.4-.867-.6-2.113-.6-3.74 0-1.613.2-2.847.6-3.7.4-.853 1.18-1.28 2.34-1.28 1.147 0 1.92.433 2.32 1.3.4.853.6 2.08.6 3.68Z"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 178.5,
    cy: 280.5,
    r: 33.2,
    fill: "url(#".concat(_id3, ")")
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 178.5,
    cy: 280.5,
    r: 41.5,
    fill: "url(#".concat(_id4, ")"),
    opacity: 0.2
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M172.388 280.767h-3.32v3.353h-1.842v-3.353h-3.304v-1.743h3.304v-3.37h1.842v3.37h3.32v1.743Zm9.484-5.113h-5.794v3.486c.266-.343.642-.614 1.129-.813a4.025 4.025 0 0 1 1.61-.316c.819 0 1.5.178 2.042.532.542.343.941.802 1.195 1.377.266.576.399 1.212.399 1.909 0 1.229-.343 2.225-1.029 2.988-.687.753-1.683 1.129-2.988 1.129-1.229 0-2.219-.326-2.972-.979-.752-.653-1.162-1.522-1.228-2.606h1.859c.1.597.343 1.068.73 1.411.399.343.902.514 1.511.514.753 0 1.317-.227 1.693-.68.376-.454.565-1.057.565-1.81 0-.708-.194-1.261-.581-1.66-.388-.409-.941-.614-1.66-.614-.509 0-.958.111-1.345.332a2.047 2.047 0 0 0-.83.88h-1.843v-6.756h7.537v1.676Zm2.241 4.283c0 1.87.332 3.337.996 4.399.664 1.051 1.771 1.577 3.32 1.577 1.55 0 2.656-.531 3.32-1.594.664-1.062.996-2.523.996-4.382 0-1.848-.332-3.298-.996-4.349-.664-1.063-1.77-1.594-3.32-1.594-1.549 0-2.656.526-3.32 1.577-.664 1.052-.996 2.507-.996 4.366Zm6.74 0c0 1.35-.166 2.385-.498 3.104-.332.72-.974 1.079-1.926 1.079-.963 0-1.61-.359-1.942-1.079-.332-.719-.498-1.754-.498-3.104 0-1.339.166-2.363.498-3.071.332-.708.979-1.062 1.942-1.062.952 0 1.594.359 1.926 1.079.332.708.498 1.726.498 3.054Z"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 289,
    cy: 244,
    r: 40,
    fill: "url(#".concat(_id5, ")")
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 289,
    cy: 244,
    r: 50,
    fill: "url(#".concat(_id6, ")"),
    opacity: 0.2
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M269.654 244.84h-4v4.04h-2.22v-4.04h-3.98v-2.1h3.98v-4.06h2.22v4.06h4v2.1Zm6.106 1.08a4.23 4.23 0 0 1-.38 1.72c-.24.573-.62 1.107-1.14 1.6h7.14v1.82h-9.36l-.28-1.18c.626-.6 1.086-1.193 1.38-1.78.306-.6.46-1.313.46-2.14 0-.267-.047-.607-.14-1.02h-2.36v-1.56h1.86a19.493 19.493 0 0 1-.44-1.58c-.107-.48-.16-.98-.16-1.5 0-.813.18-1.527.54-2.14a3.738 3.738 0 0 1 1.56-1.42c.666-.347 1.433-.52 2.3-.52 1.4 0 2.5.393 3.3 1.18.8.787 1.26 1.813 1.38 3.08h-2.12c-.067-.707-.32-1.28-.76-1.72-.44-.44-1.014-.66-1.72-.66-.667 0-1.214.213-1.64.64-.427.413-.64 1.013-.64 1.8 0 .413.053.827.16 1.24.12.413.293.947.52 1.6h3.62v1.56h-3.18c.066.36.1.687.1.98Zm12.609-9.48c.933 0 1.733.167 2.4.5.667.32 1.167.767 1.5 1.34.347.573.52 1.213.52 1.92 0 .893-.253 1.64-.76 2.24-.493.587-1.193.94-2.1 1.06v.1c.973.28 1.733.7 2.28 1.26.56.547.84 1.307.84 2.28 0 1.187-.393 2.153-1.18 2.9-.787.733-1.913 1.1-3.38 1.1-1.507 0-2.72-.38-3.64-1.14-.92-.773-1.447-1.913-1.58-3.42h2.26c.08.8.367 1.44.86 1.92.493.467 1.16.7 2 .7.787 0 1.387-.207 1.8-.62.427-.413.64-.947.64-1.6 0-.787-.307-1.387-.92-1.8-.6-.413-1.473-.62-2.62-.62h-.54v-1.88h.54c2.173.027 3.26-.713 3.26-2.22 0-.653-.2-1.167-.6-1.54-.4-.373-.947-.56-1.64-.56s-1.273.213-1.74.64c-.467.413-.747 1.02-.84 1.82h-2.24c.093-1.387.56-2.46 1.4-3.22.84-.773 2-1.16 3.48-1.16Zm6.915 7.4c0 2.253.4 4.02 1.2 5.3.8 1.267 2.133 1.9 4 1.9s3.2-.64 4-1.92c.8-1.28 1.2-3.04 1.2-5.28 0-2.227-.4-3.973-1.2-5.24-.8-1.28-2.133-1.92-4-1.92s-3.2.633-4 1.9c-.8 1.267-1.2 3.02-1.2 5.26Zm8.12 0c0 1.627-.2 2.873-.6 3.74-.4.867-1.173 1.3-2.32 1.3-1.16 0-1.94-.433-2.34-1.3-.4-.867-.6-2.113-.6-3.74 0-1.613.2-2.847.6-3.7.4-.853 1.18-1.28 2.34-1.28 1.147 0 1.92.433 2.32 1.3.4.853.6 2.08.6 3.68Zm4.341 0c0 2.253.4 4.02 1.2 5.3.8 1.267 2.133 1.9 4 1.9s3.2-.64 4-1.92c.8-1.28 1.2-3.04 1.2-5.28 0-2.227-.4-3.973-1.2-5.24-.8-1.28-2.133-1.92-4-1.92s-3.2.633-4 1.9c-.8 1.267-1.2 3.02-1.2 5.26Zm8.12 0c0 1.627-.2 2.873-.6 3.74-.4.867-1.173 1.3-2.32 1.3-1.16 0-1.94-.433-2.34-1.3-.4-.867-.6-2.113-.6-3.74 0-1.613.2-2.847.6-3.7.4-.853 1.18-1.28 2.34-1.28 1.147 0 1.92.433 2.32 1.3.4.853.6 2.08.6 3.68Z"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 483,
    cy: 287,
    r: 32,
    fill: "url(#".concat(_id7, ")")
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 483,
    cy: 287,
    r: 40,
    fill: "url(#".concat(_id8, ")"),
    opacity: 0.2
  }), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M469.82 287.872h-3.2v3.232h-1.776v-3.232h-3.184v-1.68h3.184v-3.248h1.776v3.248h3.2v1.68Zm4.885.864c0 .458-.102.917-.304 1.376a3.796 3.796 0 0 1-.912 1.28h5.712v1.456h-7.488l-.224-.944c.501-.48.869-.955 1.104-1.424.245-.48.368-1.051.368-1.712a3.89 3.89 0 0 0-.112-.816h-1.888v-1.248h1.488c-.15-.47-.267-.891-.352-1.264a5.476 5.476 0 0 1-.128-1.2c0-.651.144-1.222.432-1.712a2.98 2.98 0 0 1 1.248-1.136c.533-.278 1.146-.416 1.84-.416 1.12 0 2 .314 2.64.944.64.629 1.008 1.45 1.104 2.464h-1.696c-.054-.566-.256-1.024-.608-1.376-.352-.352-.811-.528-1.376-.528-.534 0-.971.17-1.312.512-.342.33-.512.81-.512 1.44 0 .33.042.661.128.992.096.33.234.757.416 1.28h2.896v1.248h-2.544c.053.288.08.549.08.784Zm5.495-5.52v-1.712h3.616V292.8h-1.92v-9.584H480.2Zm5.53 3.856c0 1.802.32 3.216.96 4.24.64 1.013 1.707 1.52 3.2 1.52 1.494 0 2.56-.512 3.2-1.536.64-1.024.96-2.432.96-4.224 0-1.782-.32-3.179-.96-4.192-.64-1.024-1.706-1.536-3.2-1.536-1.493 0-2.56.506-3.2 1.52-.64 1.013-.96 2.416-.96 4.208Zm6.496 0c0 1.301-.16 2.298-.48 2.992-.32.693-.938 1.04-1.856 1.04-.928 0-1.552-.347-1.872-1.04-.32-.694-.48-1.691-.48-2.992 0-1.291.16-2.278.48-2.96.32-.683.944-1.024 1.872-1.024.918 0 1.536.346 1.856 1.04.32.682.48 1.664.48 2.944Zm3.473 0c0 1.802.32 3.216.96 4.24.64 1.013 1.707 1.52 3.2 1.52 1.494 0 2.56-.512 3.2-1.536.64-1.024.96-2.432.96-4.224 0-1.782-.32-3.179-.96-4.192-.64-1.024-1.706-1.536-3.2-1.536-1.493 0-2.56.506-3.2 1.52-.64 1.013-.96 2.416-.96 4.208Zm6.496 0c0 1.301-.16 2.298-.48 2.992-.32.693-.938 1.04-1.856 1.04-.928 0-1.552-.347-1.872-1.04-.32-.694-.48-1.691-.48-2.992 0-1.291.16-2.278.48-2.96.32-.683.944-1.024 1.872-1.024.918 0 1.536.346 1.856 1.04.32.682.48 1.664.48 2.944Z"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 585,
    cy: 205,
    r: 40,
    fill: "url(#".concat(_id9, ")")
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 585,
    cy: 205,
    r: 50,
    fill: "url(#".concat(_id10, ")"),
    opacity: 0.2
  }), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M565.918 205.84h-4v4.04h-2.22v-4.04h-3.98v-2.1h3.98v-4.06h2.22v4.06h4v2.1Zm6.105 1.08c0 .573-.126 1.147-.38 1.72-.24.573-.62 1.107-1.14 1.6h7.14v1.82h-9.36l-.28-1.18c.627-.6 1.087-1.193 1.38-1.78.307-.6.46-1.313.46-2.14 0-.267-.046-.607-.14-1.02h-2.36v-1.56h1.86a20.348 20.348 0 0 1-.44-1.58c-.106-.48-.16-.98-.16-1.5 0-.813.18-1.527.54-2.14a3.75 3.75 0 0 1 1.56-1.42c.667-.347 1.434-.52 2.3-.52 1.4 0 2.5.393 3.3 1.18.8.787 1.26 1.813 1.38 3.08h-2.12c-.066-.707-.32-1.28-.76-1.72-.44-.44-1.013-.66-1.72-.66-.666 0-1.213.213-1.64.64-.426.413-.64 1.013-.64 1.8 0 .413.054.827.16 1.24.12.413.294.947.52 1.6h3.62v1.56h-3.18c.067.36.1.687.1.98Zm7.41 3.3c2.16-1.48 3.886-2.927 5.18-4.34 1.306-1.427 1.96-2.747 1.96-3.96 0-.72-.18-1.293-.54-1.72-.347-.427-.914-.64-1.7-.64-.814 0-1.427.267-1.84.8-.414.52-.647 1.267-.7 2.24h-2.22c.093-1.613.586-2.847 1.48-3.7.906-.853 2.06-1.28 3.46-1.28 1.373 0 2.446.367 3.22 1.1.786.72 1.18 1.72 1.18 3 0 1.027-.32 2.067-.96 3.12a12.974 12.974 0 0 1-2.4 2.92 20.67 20.67 0 0 1-3.02 2.28h6.7v1.86h-9.8v-1.68Zm11.587-5.38c0 2.253.4 4.02 1.2 5.3.8 1.267 2.134 1.9 4 1.9 1.867 0 3.2-.64 4-1.92.8-1.28 1.2-3.04 1.2-5.28 0-2.227-.4-3.973-1.2-5.24-.8-1.28-2.133-1.92-4-1.92-1.866 0-3.2.633-4 1.9-.8 1.267-1.2 3.02-1.2 5.26Zm8.12 0c0 1.627-.2 2.873-.6 3.74-.4.867-1.173 1.3-2.32 1.3-1.16 0-1.94-.433-2.34-1.3-.4-.867-.6-2.113-.6-3.74 0-1.613.2-2.847.6-3.7.4-.853 1.18-1.28 2.34-1.28 1.147 0 1.92.433 2.32 1.3.4.853.6 2.08.6 3.68Zm4.341 0c0 2.253.4 4.02 1.2 5.3.8 1.267 2.134 1.9 4 1.9 1.867 0 3.2-.64 4-1.92.8-1.28 1.2-3.04 1.2-5.28 0-2.227-.4-3.973-1.2-5.24-.8-1.28-2.133-1.92-4-1.92-1.866 0-3.2.633-4 1.9-.8 1.267-1.2 3.02-1.2 5.26Zm8.12 0c0 1.627-.2 2.873-.6 3.74-.4.867-1.173 1.3-2.32 1.3-1.16 0-1.94-.433-2.34-1.3-.4-.867-.6-2.113-.6-3.74 0-1.613.2-2.847.6-3.7.4-.853 1.18-1.28 2.34-1.28 1.147 0 1.92.433 2.32 1.3.4.853.6 2.08.6 3.68Z"
  }))), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: _id,
    x1: 32,
    x2: 112,
    y1: 185,
    y2: 185,
    gradientUnits: "userSpaceOnUse"
  }, _stop || (_stop = /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17D3FF"
  })), _stop2 || (_stop2 = /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00EA90"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: _id2,
    x1: 22,
    x2: 122,
    y1: 185,
    y2: 185,
    gradientUnits: "userSpaceOnUse"
  }, _stop3 || (_stop3 = /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17D3FF"
  })), _stop4 || (_stop4 = /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00EA90"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: _id3,
    x1: 145.3,
    x2: 211.7,
    y1: 280.5,
    y2: 280.5,
    gradientUnits: "userSpaceOnUse"
  }, _stop5 || (_stop5 = /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17D3FF"
  })), _stop6 || (_stop6 = /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00EA90"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: _id4,
    x1: 137,
    x2: 220,
    y1: 280.5,
    y2: 280.5,
    gradientUnits: "userSpaceOnUse"
  }, _stop7 || (_stop7 = /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17D3FF"
  })), _stop8 || (_stop8 = /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00EA90"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: _id5,
    x1: 249,
    x2: 329,
    y1: 244,
    y2: 244,
    gradientUnits: "userSpaceOnUse"
  }, _stop9 || (_stop9 = /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17D3FF"
  })), _stop10 || (_stop10 = /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00EA90"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: _id6,
    x1: 239,
    x2: 339,
    y1: 244,
    y2: 244,
    gradientUnits: "userSpaceOnUse"
  }, _stop11 || (_stop11 = /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17D3FF"
  })), _stop12 || (_stop12 = /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00EA90"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: _id7,
    x1: 451,
    x2: 515,
    y1: 287,
    y2: 287,
    gradientUnits: "userSpaceOnUse"
  }, _stop13 || (_stop13 = /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17D3FF"
  })), _stop14 || (_stop14 = /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00EA90"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: _id8,
    x1: 443,
    x2: 523,
    y1: 287,
    y2: 287,
    gradientUnits: "userSpaceOnUse"
  }, _stop15 || (_stop15 = /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17D3FF"
  })), _stop16 || (_stop16 = /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00EA90"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: _id9,
    x1: 545,
    x2: 625,
    y1: 205,
    y2: 205,
    gradientUnits: "userSpaceOnUse"
  }, _stop17 || (_stop17 = /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17D3FF"
  })), _stop18 || (_stop18 = /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00EA90"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: _id10,
    x1: 535,
    x2: 635,
    y1: 205,
    y2: 205,
    gradientUnits: "userSpaceOnUse"
  }, _stop19 || (_stop19 = /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17D3FF"
  })), _stop20 || (_stop20 = /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00EA90"
  })))));
};
export default SvgAuctions;